{
	"hooks": {
		"exportAllSalesFromEmployee": {
			"date": "Fecha",
			"filename": "{{employeeName}}-Ventas individuales",
			"filenameEvent": "-en el evento-{{eventName}}",
			"filenamePeriod": "-desde-{{since}}-hasta-{{until}}",
			"isRefunded": "Reembolsado",
			"method": "Método",
			"refundedAt": "Reembolsado en",
			"refundedBy": "Reembolsado por",
			"title": "Ventas individuales de {{employeeName}} ",
			"titleEvent": "en el evento {{eventName}} ",
			"titlePeriod": "Desde {{since}} hasta {{until}}",
			"value": "Valor"
		},
		"exportSalesByEmployee": {
			"employee": "Empleado",
			"filename": "ventas-individuales-por-empleado-",
			"filenameEvent": "en el evento-{{eventName}}",
			"filenamePeriod": "-desde-{{since}}-hasta-{{until}}",
			"title": "Ventas individuales por empleado ",
			"titleEvent": "en el evento {{eventName}} ",
			"titlePeriod": "desde {{since}} hasta {{until}}"
		}
	},
	"parseOpenSaleMethod": {
		"credit": "Crédito",
		"debit": "Débito",
		"pix": "Pix",
		"creditInInstallments": "Pago a plazos",
		"integratedFoodVoucher": "Vale de Alimentación"
	}
}
